import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getByToken = async (tokenReceta) => {

  const query = `
    query AllReceta($tokenReceta: String) {
      allReceta(tokenReceta: $tokenReceta) {
        total
        status
        message
        recetas {
          id
          token
          medicamentosRecetados {
            id
            token
            medicamento {
              id
              token
              nombre
              codigo
              presentacion
            }
            cantidad
            dosis
            frecuencia
            duracion
            observacion
          }
        }
      }
    }
  `;

  const variables = {
    tokenReceta
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allReceta;

    if( response2.status !== 'Success' ) return null;
    if( response2.recetas.length === 0 ) return null;

    const data = response2.recetas[0];

    console.log('receta', data);

    return data;

  }catch(error){
    console.error('error al obterner la receta', error);
    return null;
  }

}


const getByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ){
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion:String) {
    allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          id
          token

          recetaSet{
            id
            token
            medicamentosRecetados{
              id
              medicamento{
                nombre
                id
                presentacion
              }
              cantidad
              dosis
              frecuencia
              duracion
              estado
              observacion
            }
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;
    if( response2.atcm[0].recetaSet.length === 0 ) return null;

    const data = response2.atcm[0].recetaSet[0];

    const dataMap = {
      id: data.id,
      token: data.token,
      medicamentos: data.medicamentosRecetados
    };

    return dataMap;

  }catch(error){
    console.error('error al obterner la receta', error);
    return null;
  }

}


const update = async ( idAtencion, dataReceta, alergias ) => {



  if(!dataReceta || dataReceta.length === 0) {
    console.error('data receta es requerido');
    return null
  }

  const query = `
  mutation MyMutation($input : UpdateMedicamentoRecetadoInput!, $idAtencion : ID, $alergias : String) {
     updateMedicamentoRecetado(
       input: $input, idAtencion : $idAtencion, alergias : $alergias
     ) {
       status
       message
       medicamentoRecetado {
         id
         medicamento {
           nombre
         }
         cantidad
         dosis
         frecuencia
       }
     }
   }
  `;


  let vars = dataReceta
  for (let i = 0; i < vars.length; i++) {

 
    const variables = {
      idAtencion : idAtencion,
      input: {
        id: vars[i].id,
        receta: vars[i].idReceta,
        cantidad: parseInt(vars[i].cantidad),
        dosis: vars[i].dosis,
        duracion: vars[i].duracion,
        frecuencia: vars[i].frecuencia,
        medicamento: vars[i].medicamentoID,
        estado : vars[i].estado,
        observacion : vars[i].observacion
      },
      alergias      : alergias

    }

    try {
      const response = await axios.post(rutas.axios + "api", {
        query,
        variables,
      });

      if (response.data.data.updateMedicamentoRecetado.status === "success") {
      }

    } catch (error) {
      console.error("Error en la edicion de recetas:", error.response.data);
    }
  }
}




const register = async ( idAtencion, dataReceta, alergias = 'Ninguna' ) => {


  if(!idAtencion) {
    console.error('id atencion es requerido');
    return null
  }

  if(!dataReceta || dataReceta.length === 0) {
    console.error('data receta es requerido');
    return null
  }

  const query = `
    mutation CrearMedicamentosRecetados(
      $datos: [MedicamentoRecetadoInput!]!,
      $alergias : String, 
      $citaId: String!
    ) {
      crearMedicamentoRecetados(datos: $datos, citaId: $citaId, alergias : $alergias) {
        medicamentoRecetado { id }
        message
        status
      }
    }
  `;

  const itemsReceta = dataReceta.map((item) => ({
    medicamento   : item.medicamentoID,
    cantidad      : parseInt(item.cantidad, 10),
    dosis         : item.dosis,
    frecuencia    : item.frecuencia,
    duracion      : item.duracion,
    observacion   : item.observacion,
    alertaIgnorada: item.alertaOmitida
    
    
  }));

  const variables = {
    datos: itemsReceta,
    citaId: idAtencion,
    alergias      : alergias
  };

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.crearMedicamentoRecetados;
    if( response2.status !== 'success' ) return null;

    const data = response2.medicamentoRecetado;
    return data;

  }catch(error){
    console.error('error al registrar la receta', error);
    return null;
  }
}



const getAllByPaciente = async (idPaciente) => {


  const query = `
    query AllReceta($idPaciente: ID) {
      allReceta(idPaciente: $idPaciente) {
        total
        status
        message
        recetas {
          id
          fechaCreacion
          token

          medicamentosRecetados {
            medicamento {
              nombre
              id
          }
          }
        }
      }
    }
  `;

  const variables = {
    idPaciente
  };


  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });

    if(response.status !== 200 ) return null;

    const response2 = response.data.data.allReceta;
    if( response2.status !== 'Success' ) return null;

    const data = response2.recetas;
    return data;

  } catch (error) {
    console.error("Error fetching recetas by paciente:", error);
    return null;
  }
}


export const recetaService = {
  register,
  update,
  getByToken,
  getByAtencion,
  getAllByPaciente
}